// src/styles/colors.js
export const color = {
  primary: '#FF7D33',     // Bright orange
  primaryDark: '#E56C2B', // Darker orange
  secondary: '#FFF8F0',   // Cream background
  accent: '#FFB380',      // Light orange
  textDark: '#5a4a42',    // Dark cream/brown text
  textLight: '#FFF8F0',   // Cream text
  white: '#FFFFFF',
  black: '#000000',
  gray: '#888888',
  lightGray: '#E0E0E0'
};